import React from "react";
import resumeFile from "../documents/Ifran_Ali_Resume.pdf";

const Resume = ({ classicHeader, darkTheme }) => {
  const educationDetails = [
    {
      yearRange: "2022",
      title: "Post Graduate Certificate In Computer Science",
      place: "Queensland University of Technology",
      desc: "DISTINCTION GPA: 6.0",
    },
    {
      yearRange: "2014 - 2015",
      title: "Diploma in Computing",
      place: "University of the South Pacific",
      // desc: "Lisque persius interesset his et, in quot quidam persequeris vim, ad mea essent possim iriure.",
    },
    {
      yearRange: "2006 - 2008",
      title: "Bachelor of Engineering Technology",
      place: "University of the South Pacific",
      desc: "Incomplete",
    },
  ];

  const experienceDetails = [
    {
      yearRange: "2023 - Present",
      title: "Full Stack Software Engineer",
      place: "OpenGear",
      desc: "Lighthouse Software Developer(Control Center for Network Resilience Platform/Console Server). Python Web API backend and Javascript Frontend Web development",
    },
    {
      yearRange: "2020 - 2022",
      title: "Python Developer",
      place: "DHL Express",
      desc: "Design, develop Python/Django web applications for DHL. Project include Web applications such as DHL Express Transit Service , these services include tracking and managing large shipment and later billing the shipment.",
    },
    {
      yearRange: "2019 - 2020",
      title: "Robotics Process Automation Analyst(Python Developer)",
      place: "DHL Express",
      desc: "Design, develop Python/Django web applications for DHL. Web applications were part of DHL Express Transit Service , these services include tracking and managing large shipment and later billing the shipments. Responsible for all aspects of the analysis, design, development, building and testing of Process Automation solutions. Create process documentation workflows and knowledge articles.",
    },
    {
      yearRange: "2016 - 2018",
      title: "Application Solution Support -AU",
      place: "DHL Express",
      desc: "Providing Level 1&2 incident support & Request for Standard Change to AU users for local applications. Performing a series of proactive checks on local application performance, data quality checking for Clearance ICD data and Basic Release To Production (RTP) Testing.",
    },
    {
      yearRange: "2015 - 2016",
      title: "Manage Helpdesk",
      place: "Vinod Patel Company Limited",
      desc: "I managed Helpdesk operations which mainly does Software and Hardware troubleshooting for Vinod Patel's Fourteen Home & Building Branches along with almost as many Home & Living Branches. These services also cover sister companies namely Ba Industries Limited, Wheels Pacific, Pacific Flexibles and VP Works, while my responsibilities also included helping with System and Network Administration",
    },
    {
      yearRange: "2012 - 2015",
      title: "Acting IT Systems Administrator",
      place: "Mana Island Resort & Spa",
      desc: "Key responsibilities with the job criteria included maintaining and implementing Information System, Network Structure. The position also required supporting and maintaining Application Servers and other computer systems, furthermore maintenance planning and responding to service outages were other responsibilities.",
    },
    {
      yearRange: "2011 - 2012",
      title: "IT Support Cost Control",
      place: "Mana Island Resort & Spa",
      desc: "Analysing and Implementing cost control measures for all departments for the Resort. Job Criteria mainly included use of Softwares like Materials Control, Microsoft Office Products and other softwares to analyse cost acquired during a month and implementing suitable cost measures from the Analysis.",
    },
    {
      yearRange: "2010 - 2011",
      title: "IT Support Food & Beverage",
      place: "Mana Island Resort & Spa",
      desc: "Design, develop Python/Django web applications for DHL. Web applications were part of DHL Express Transit Service , these services include tracking and managing large shipment and later billing the shipments. Responsible for all aspects of the analysis, design, development, building and testing of Process Automation solutions. Create process documentation workflows and knowledge articles.",
    },
    {
      yearRange: "2009 - 2010",
      title: "Computer Repair Technician",
      place: "Macro Signs",
      desc: "PC maintenance and software trouble shooting for external companies. Broad use Corel Draw Software for designing Advertisment Banners.",
    },
  ];

  const certifications = [
    { year: "2023", title: "ICAgile Certified Professional" },
    {
      year: "2022",
      title: "Azure Developer (AZ‑204), DevOps Engineer (AZ‑400)",
    },
    { year: "2020", title: "Django for Everybody, Python 3 Programming" },
    { year: "2019", title: "UI Path Advanced Automation" },
    { year: "2017", title: "Cisco Certified Network Associate" },
  ];

  const skills = [
    {
      name: "Python",
      percent: 95,
    },
    {
      name: "Django",
      percent: 95,
    },
    {
      name: "HTML/CSS",
      percent: 95,
    },
    {
      name: "JavaScript",
      percent: 80,
    },
    {
      name: "React",
      percent: 80,
    },
    {
      name: "Angular",
      percent: 80,
    },
    {
      name: "Bootstrap",
      percent: 90,
    },
    {
      name: "MY SQL",
      percent: 85,
    },
    {
      name: "MongoDB",
      percent: 50,
    },
    {
      name: "JQuery",
      percent: 85,
    },
    {
      name: "Git/GitHub",
      percent: 90,
    },
    {
      name: "Node Js",
      percent: 50,
    },
    {
      name: "WordPress",
      percent: 80,
    },
    {
      name: "PHP",
      percent: 70,
    },
    {
      name: "C++",
      percent: 50,
    },
    {
      name: "C#",
      percent: 50,
    },
    {
      name: "SASS",
      percent: 50,
    },
    {
      name: "Bash Scripting",
      percent: 50,
    },
  ];
  const boxMinHeight = 180;

  return (
    <section
      id="resume"
      className={"section " + (darkTheme ? "bg-dark-1" : "")}
    >
      <div className={"container " + (classicHeader ? "" : "px-lg-5")}>
        {/* Heading */}
        <div className="position-relative d-flex text-center mb-5">
          <h2
            className={
              "text-24  text-uppercase fw-600 w-100 mb-0 " +
              (darkTheme ? "text-muted opacity-1" : "text-light opacity-4")
            }
          >
            Accomplishments
          </h2>
          <p
            className={
              "text-9 text-dark fw-600 position-absolute w-100 align-self-center lh-base mb-0 " +
              (darkTheme ? "text-white" : "text-dark")
            }
          >
            {" "}
            Resume
            <span className="heading-separator-line border-bottom border-3 border-primary d-block mx-auto" />
          </p>
        </div>
        {/* Heading end*/}
        <div className="row gx-5">
          {/* My Education */}
          <div className="col-md-6">
            <h2
              className={
                "text-6 fw-600 mb-4 " + (darkTheme ? "text-white" : "")
              }
            >
              Education
            </h2>
            {educationDetails.length > 0 &&
              educationDetails.map((value, index) => (
                <div
                  key={index}
                  className={
                    "bg-white  rounded p-4 mb-4 " +
                    (darkTheme ? "bg-dark" : "bg-white border")
                  }
                >
                  <p className="badge bg-primary text-2 fw-400">
                    {value.yearRange}
                  </p>
                  <h3 className={"text-5 " + (darkTheme ? "text-white" : "")}>
                    {value.title}
                  </h3>
                  <p className={darkTheme ? "text-primary" : "text-danger"}>
                    {value.place}
                  </p>
                  <p className={"mb-0 " + (darkTheme ? "text-white-50" : "")}>
                    {value.desc}
                  </p>
                </div>
              ))}

            {/* Certifications */}
            <h3
              className={
                "text-6 fw-600 mt-3 mb-3 " + (darkTheme ? "text-white" : "")
              }
            >
              CERTIFICATIONS
            </h3>

            {certifications.length > 0 &&
              certifications.map((cert, index) => (
                <div
                  key={index}
                  className={
                    // match education box padding and margins so heights align visually
                    "bg-white rounded p-4 mb-4 " +
                    (darkTheme ? "bg-dark" : "bg-white border")
                  }
                  style={{ minHeight: boxMinHeight }}
                >
                  <div>
                    <p className="badge bg-primary text-2 fw-400">
                      {cert.year}
                    </p>
                    <h4
                      className={
                        "text-5 mt-2 mb-0 " + (darkTheme ? "text-white" : "")
                      }
                    >
                      {cert.title}
                    </h4>
                  </div>
                </div>
              ))}
          </div>

          {/* My Experience */}
          <div className="col-md-6">
            <h2
              className={
                "text-6 fw-600 mb-4 " + (darkTheme ? "text-white" : "")
              }
            >
              Experience
            </h2>
            {experienceDetails.length > 0 &&
              experienceDetails.map((value, index) => (
                <div
                  key={index}
                  className={
                    "bg-white  rounded p-4 mb-4 " +
                    (darkTheme ? "bg-dark" : "bg-white border")
                  }
                >
                  <p className="badge bg-primary text-2 fw-400">
                    {value.yearRange}
                  </p>
                  <h3 className={"text-5 " + (darkTheme ? "text-white" : "")}>
                    {value.title}
                  </h3>
                  <p className={darkTheme ? "text-primary" : "text-danger"}>
                    {value.place}
                  </p>
                  <p className={"mb-0 " + (darkTheme ? "text-white-50" : "")}>
                    {value.desc}
                  </p>
                </div>
              ))}
          </div>
        </div>

        {/* My Skills */}
        <h2
          className={
            "text-6 fw-600 mt-4 mb-4 " + (darkTheme ? "text-white" : "")
          }
        >
          My Skills
        </h2>
        <div className="row gx-5">
          {skills.length > 0 &&
            skills.map((skill, index) => (
              <div key={index} className="col-md-6">
                <p
                  className={
                    " fw-500 text-start mb-2 " +
                    (darkTheme ? "text-light" : "text-dark")
                  }
                >
                  {skill.name}{" "}
                  <span className="float-end">{skill.percent}%</span>
                </p>
                <div
                  className={
                    "progress progress-sm mb-4 " + (darkTheme ? "bg-dark" : "")
                  }
                >
                  <div
                    className="progress-bar"
                    role="progressbar"
                    style={{ width: skill.percent + "%" }}
                    aria-valuenow={skill.percent}
                    aria-valuemin={0}
                    aria-valuemax={100}
                  />
                </div>
              </div>
            ))}
        </div>
        <div className="text-center mt-5">
          <a
            className="btn btn-outline-secondary rounded-pill shadow-none"
            href={resumeFile}
            download
          >
            Download CV
            <span className="ms-1">
              <i className="fas fa-download" />
            </span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Resume;
